const mobileMenuButton = document.getElementById("mobile-menu-button") as HTMLButtonElement | null;
const mobileMenu = document.getElementById("mobile-menu") as HTMLElement | null;
const transitionTime = getTransitionTime();

function getTransitionTime() {
  /* Get transition-time from css */
  const raw = getComputedStyle(document.documentElement).getPropertyValue("--transition-time-half").trim();

  // convert to milliseconds if ends with "ms" or "s"
  let ms;
  if (raw.endsWith("ms")) {
    ms = parseFloat(raw);
  } else if (raw.endsWith("s")) {
    ms = parseFloat(raw) * 1000;
  } else {
    ms = parseFloat(raw);
  }

  return Number.isFinite(ms) ? ms : 200;
}

function openMobileMenu(): void {
  if (!mobileMenu) return;
  mobileMenu.hidden = false;
  mobileMenu.inert = false;
  mobileMenuButton?.setAttribute("aria-expanded", "true");
  toggleInert(true, [mobileMenuButton, mobileMenu]);

  // For animation
  setTimeout(function () {
    mobileMenuButton?.classList.add("sas-hamburger__btn--open");
  }, transitionTime);
}

function closeMobileMenu(): void {
  if (!mobileMenu) return;
  mobileMenu.hidden = true;
  mobileMenuButton?.setAttribute("aria-expanded", "false");
  mobileMenuButton?.focus();
  toggleInert(false);

  // Set mobile menu to inert to avoid hidden tabbing.
  mobileMenu.inert = true;

  // For animation
  setTimeout(function () {
    mobileMenuButton?.classList.remove("sas-hamburger__btn--open");
  }, transitionTime);
}

function toggleInert(state: boolean, exceptions: Array<HTMLElement | null> = []): void {
  const validExceptions = exceptions.filter((el): el is HTMLElement => el !== null);
  Array.from(document.body.children).forEach((el) => {
    if (validExceptions.includes(el as HTMLElement)) return;
    (el as HTMLElement).inert = state;
  });
}

mobileMenuButton?.addEventListener("click", () => {
  mobileMenuButton.getAttribute("aria-expanded") === "true" ? closeMobileMenu() : openMobileMenu();
});

document.addEventListener("keydown", (e: KeyboardEvent) => {
  if (e.key === "Escape" && mobileMenuButton?.getAttribute("aria-expanded") === "true") {
    closeMobileMenu();
  }
});

/* Add data-scrolled tag on body if page is scrolled */
const sentinel = document.createElement("div");
sentinel.style.position = "absolute";
sentinel.style.top = "0";
sentinel.style.height = "1px";
sentinel.style.width = "1px";
sentinel.style.pointerEvents = "none";

document.body.prepend(sentinel);

const observer = new IntersectionObserver(
  ([entry]) => {
    if (entry.isIntersecting) {
      delete document.body.dataset.scrolled;
    } else {
      document.body.dataset.scrolled = "true";
    }
  },
  {
    root: null, // viewport
    threshold: 0,
    rootMargin: "-1px 0px 0px 0px", // 👈 prevents jitter
  }
);

observer.observe(sentinel);
